import { Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import Chart from 'react-apexcharts';
// import "./styles/RewardStyle.css";
import { useNavigate } from "react-router-dom";
import { MAIN_COLOR, ACCENT_LIGHT_COLOR } from "components/styles/constants.styles";
import { ApexOptions } from "apexcharts";
import ChartCard from "pages/DashboardCards/ChartCard";
import { splitInTheMiddleSpace, truncateString } from "pages/DashboardCards/utils";

interface TooltipProps {
    active: any;
    payload: any;
    label: any;
}
type BestCampaign = {
    name: string;
    value1: number;
    value2: number;
};
interface Props {
    bestCampaigns: BestCampaign[];
    title: string;
    value1Name: string;
    value2Name: string;
}

const MOCK_SERIES = [{
    data: [44, 55, 41, 64, 22, 43, 21]
}, {
    data: [53, 32, 33, 52, 13, 44, 32]
}];

const MOCK_CATEGORIES = ["2001", "2002", "2003", "2004", "2005", "2006", "2007"];

const getSortedValues = (revenueReports: BestCampaign[]) => {
    const sortedValue = revenueReports.sort((a, b) => {
        const sumA = a.value1 + a.value2;
        const subB = b.value1 + b.value2;
        if (sumA > subB) {
            return -1;
        }

        if (sumA < subB) {
            return 1;
        }
        return 0;
    }).reduce((
        acc: { names: string[], value1: number[]; value2: number[]; },
        item: BestCampaign
    ) => {
        return {
            names: [...acc.names, item.name],
            value1: [...acc.value1, item.value1],
            value2: [...acc.value2, item.value2],
        };
    }, { value1: [], value2: [], names: [] });

    return sortedValue;
};

const getSeries = (value2: number[], value1: number[], value1Name: string, value2Name: string, t: any) => {
    return [{
        name: t(value1Name),
        data: value2
    }, {
        name: t(value2Name),
        data: value1
    }];

};

const getOptions = (categories: string[], t: any) => {
    const options: ApexOptions = {
        chart: {
            type: 'bar',
            height: 430,
            toolbar: {
                show: false,
            },
            events: {
                click: function (event, chartContext, config) {
                    console.log({ event, chartContext, config });
                    // The last parameter config contains additional information like `seriesIndex` and `dataPointIndex` for cartesian charts
                }
            }
        },
        colors: [MAIN_COLOR.EXTRA_DARK, MAIN_COLOR.EXTRA_LIGTH],
        plotOptions: {
            bar: {
                dataLabels: {
                    position: 'top',
                },
                borderRadius: [3],
            },
        },
        dataLabels: {
            enabled: false,
            offsetX: -6,
            style: {
                fontSize: '12px',
                colors: ['#fff']
            }
        },
        yaxis: {
            labels: {
                style: {
                    colors: '#6E6B7B',
                    fontSize: '12px', fontFamily: "Montserrat,sans-serif"
                },
                formatter: function (val: any) {
                    return `${val} ${t('LEI')}`;
                }
            }
        },
        stroke: {
            show: true,
            width: 1,
            colors: ['#fff']
        },
        tooltip: {
            style: {
                fontSize: '12px', fontFamily: "Montserrat,sans-serif"
            },
            x: {
                formatter: function (val: any, formatterOptions: any) {
                    return categories[formatterOptions.dataPointIndex];
                }
            },
            y: {
                formatter: function (val: any) {
                    return `${Math.abs(val)} ${t("LEI")}`;
                }
            },
            shared: true,
            intersect: false
        },
        xaxis: {
            categories: categories.map((item: string) => splitInTheMiddleSpace(item, 8)),
        },
    };

    return options;
};

const DoubleVerticalBar = ({ bestCampaigns, title, value1Name, value2Name }: Props) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    if (!bestCampaigns) {
        return (
            <ChartCard
                title={t(title)}
                noAvailableData
            >
                <Chart
                    options={getOptions(MOCK_CATEGORIES, t)}
                    series={MOCK_SERIES}
                    type='bar'
                    height={350}
                />
            </ChartCard>
        );
    }

    const { value1, value2, names } = getSortedValues(bestCampaigns);

    const series = getSeries(value1, value2, value1Name, value2Name, t);
    const options = getOptions(names, t);

    return (
        <ChartCard title={t(title)}>
            <Chart
                options={options}
                series={series}
                type='bar'
                height={350}
            />
        </ChartCard>
    );
};

export default DoubleVerticalBar;